import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var billDetailRoute = [{
  path: "detail/:id",
  name: "billDetail",
  component: function component() {
    return import("./detail.vue");
  }
}];